import styled from "styled-components";

export const Container = styled.div`
  width: 50%;
  max-width: 50%;
  height: 75px;
  max-height: 75px;
`;
